import { services } from '../../data/services';

export default function ServicesPreview({ setActiveTab }) {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Core Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Powering global innovation with flexible, borderless tech solutions.

</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.slice(0, 3).map((service, index) => (
            <div key={index} className="service-card bg-white p-8 rounded-lg shadow-md transition duration-300">
              <div className="text-blue-600 text-4xl mb-6">
                <i className={`fas fa-${service.icon}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button 
            onClick={() => setActiveTab('services')} 
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition duration-300"
          >
            View All Services
          </button>
        </div>
      </div>
    </section>
  );
}